module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.f4769f9bdb7466be6508.eot";


//////////////////
// WEBPACK FOOTER
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/assets/fonts/bootstrap/glyphicons-halflings-regular.eot?v=4.4.0
// module id = WutY
// module chunks = 1